<template>
  <div class="base-contact-card" :class="{ 'is-secondary': isSecondary }">
    <BaseIcon name="user" />
    <div class="base-contact-card__content">
      <div>
        {{ contact.name }}
      </div>
      <div v-if="contact.email" class="base-contact-card__email-row">
        {{ contact.email }}
        <BaseRoundButton
          class="base-contact-card__copyLink"
          @click.native="onCopyEmail()"
          :size="24"
          :tooltip-text="$t('actions.copyLink')"
          tooltipPlacement="top"
          icon="copy"
          is-transparent
          is-neutral
        />
      </div>
      <div v-if="contact.telephone">T {{ contact.telephone }}</div>
      <div v-if="contact.faxNumber">F {{ contact.faxNumber }}</div>
      <div v-if="contact.url">
        {{ contact.url }}
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import BaseRoundButton from '@/components/base/BaseRoundButton';
import { copyTextToClipboard } from '@/util/clipboard';

export default {
  name: 'BaseContactTag',
  components: {
    BaseIcon,
    BaseRoundButton,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    onCopyEmail() {
      copyTextToClipboard(
        this.contact.email,
        () => this.$toast.success(this.$t('page.analysis.text-selection.copy.success')),
        () => this.$toast.error(this.$t('page.analysis.text-selection.copy.error')),
      );
    },
  },
};
</script>

<style lang="scss">
.base-contact-card {
  display: flex;
  gap: 16px;
  color: $color-normal;
  align-items: center;
  border-radius: $border-radius-medium;
  padding: 8px 16px;
  width: max-content;

  &.is-secondary {
    background: $color-neutral-pale;
  }

  .base-icon {
    height: 16px;
    width: 16px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__email-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
